import { render, staticRenderFns } from "./GetDataSources.vue?vue&type=template&id=400ffe60"
import script from "./GetDataSources.vue?vue&type=script&lang=js"
export * from "./GetDataSources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports